// extracted by mini-css-extract-plugin
module.exports = {"root":"CanvasEmbed_root__lEk3V","frame":"CanvasEmbed_frame__CSYBM","controls":"CanvasEmbed_controls__V5JMQ"};